import Vue from 'vue'
import Vuex from 'vuex'
// import modules from './modules';
import getters from './getters'

Vue.use(Vuex)

const state = {
  active: 0,
  isOne: true
}

const mutations = {
  check (state, index) {
    // console.log(index)
    state.active = index
  },
  one (state, index) {
    state.active = index
    state.isOne = false
  }
}

const actions = {}

export default new Vuex.Store({
  // modules,
  getters,
  state,
  mutations,
  actions
})
